import React, { useMemo } from "react";
import { NavLink } from "react-router-dom";
import { Bubble } from "../../common/StyledComponents";
import MoneyReturn from "./MoneyReturn";

function SidebarNavLink(props) {
  if (!props.url) {
    const layout = useMemo(() => {
      if (!props.uuid) return <div>Nėra priskirtas UUID</div>;
      return (
        <MoneyReturn
          title={props.name}
          file_download={props.uuid.includes("imports/money_refund")}
        />
      );
    }, [props.uuid]);

    return layout;
  }
  return (
    <li className="nav-item">
      <NavLink
        activeClassName="current-link"
        to={props.url.replace(":page", "1")}
        className={
          props.sub
            ? "nav-link sidebar-link subnav-item cursor-pointer"
            : `nav-link px-3 mb-1 sidebar-link cursor-pointer`
        }
      >
        {props.children}
        {props.name}
        {!!props.dot && (
          <Bubble width={13} up={true}>
            {props.dot}
          </Bubble>
        )}
      </NavLink>
    </li>
  );
}
export default SidebarNavLink;
